import React, { useState, useEffect } from 'react';

import checkAgeGroupsSum from '../../../../TargetAudience/helpers/checkAgeGroupsSum/checkAgeGroupsSum';
import resetCrossedSample from '../../../../TargetAudience/helpers/resetCrossedSample/resetCrossedSample';
import getAccountManagementSampleSizeChargeWarning from '../../../../SurveyBuilder/helpers/getAccountManagementSampleSizeChargeWarning/getAccountManagementSampleSizeChargeWarning';
import getPermissionValue from '../../../../SurveyBuilder/helpers/getPermissionValue';
import { creditsToEuros } from '../../../../../../../portals/AccountManagement/helpers/creditsConversion/creditsConversion';

import useDebounce from '../../../../../../../campaigns/components/DebounceInput/debounceHook';

import NumberInput from './NumberInput';

export default ({
  survey,
  setConfirmationPopup,
  surveyRefetch,
  api,
  defaultConstants
}) => {
  const [maxResponses, setMaxResponses] = useState(survey.maxResponses);
  const debouncedMaxResponsesValue = useDebounce(maxResponses, 300);

  const userFilter = survey.userFilter ? JSON.parse(survey.userFilter) : {};
  const [surveyPermissionsCharge, setSurveyPermissionsCharge] = useState({});

  const updateSurveyTargetAudience = async (attributes, waitingTime) => {
    await api(
      'updateTargetAudience',
      {
        variables: {
          survey: survey.id,
          ...attributes
        }
      },
      waitingTime
    );
    await surveyRefetch();
  };

  const onUserFilterChange = (parsedUserFilter, filterSettings) => {
    if (parsedUserFilter) {
      let updateProperties = {
        userFilter: JSON.stringify(parsedUserFilter)
      };

      if (filterSettings) {
        updateProperties = {
          ...updateProperties,
          filterSettings
        };
      }

      updateSurveyTargetAudience(updateProperties);
    }
  };

  useEffect(
    () => {
      updateSurveyTargetAudience({ maxResponses }, 0);

      // Calculate survey permissions charge after change
      const calculatedSurveyPermissionsCharge = getAccountManagementSampleSizeChargeWarning(
        {
          ...survey,
          maxResponses
        },
        null, // accountManagement (deprecated)
        surveyPermissionsCharge,
        defaultConstants.accountManagementDefaultPermissionValues
      );
      setSurveyPermissionsCharge(calculatedSurveyPermissionsCharge);

      if (
        calculatedSurveyPermissionsCharge &&
        calculatedSurveyPermissionsCharge.accountManagementSampleSizeWarning
      ) {
        const sampleSizeIncludedInLicence = getPermissionValue(
          survey,
          'sampleSizeIncludedInLicence'
        );

        const differenceInSampleSize =
          maxResponses - (sampleSizeIncludedInLicence || 0);

        const confirmationPopup = {
          onClick: () => {},
          onClose: () => setConfirmationPopup(null),
          title: 'Are you sure?',
          description: `The sample size you have entered exceeds the number of respondents included in your license by ${differenceInSampleSize}. Therefore, an additional charge of ${creditsToEuros(
            calculatedSurveyPermissionsCharge.surveySampleSizeChargeAmount.total
          )} euros will be applied.`
        };

        setConfirmationPopup(confirmationPopup);
      }

      if (
        userFilter &&
        survey.filterSettings &&
        survey.filterSettings.crossedSample &&
        checkAgeGroupsSum(userFilter, maxResponses) !== 100
      ) {
        const newUserFilter = { ...userFilter };
        resetCrossedSample(
          newUserFilter,
          survey.filterSettings,
          onUserFilterChange
        );
      }
    },
    [debouncedMaxResponsesValue]
  );

  return (
    <NumberInput
      label="Total sample size"
      required
      value={maxResponses}
      setValue={setMaxResponses}
      placeholder="300"
    />
  );
};
